export const checkArabicValidation = (_: any, text: string): boolean => {
	try {
		if (!text?.trim()) return false;

		const arabicRegex =
			/^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF0-9\u0660-\u0669\s.,!?;:'"()\-\[\]_@#$%^&*+=/\\|~`<>«»]+$/;

		return arabicRegex.test(text);
	} catch {
		return false;
	}
};
